import superagent from 'superagent';
import config from '../config/config';
import { RemoteAPI, LocalAPI } from './api-endpoint-dictionary';
import { getCookie } from 'src/utils/dom-utils';

let apiKey = '';
let repCode = '';

export function setApiKey(data) {
  apiKey = data;
}

export function setSalesForceRepCode(data) {
  repCode = data;
}

export function callApi(url: string, customOptions?, data?, isPDF = false) {
  let _reject;
  let _request;
  const options = Object.assign(
    {},
    {
      query: {},
      method: 'GET',
      data: null,
      additionalHeaders: {},
    },
    customOptions
  );
  const requestBody = data;
  const consumerHeader = getCookie('trp-stage-routing');
  const stageval = getCookie('stageval');
  const headers = Object.assign(
    {},
    {
      apiKey: apiKey,
      Accept: isPDF ? 'application/pdf' : 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': true,
      'X-TRP-Requested-With': 'XMLHttpRequest',
      'trp-apigee-multi-target': window.location.pathname.includes('beta')
        ? 'secondary'
        : 'primary',
      'X-Frame-Options': 'SAMEORIGIN',
      'X-Content-Type-Options': 'nosniff',
      'X-XSS-Protection': 1,
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
      'import-oauth': window.location.host.includes('awstrp'),
      'trp-request-consumer-initial': 'ii-self-serve-service',
    },
    options.additionalHeaders
  );
  if (window.location.pathname.includes('salesforce') && !!repCode) {
    headers['trp-iv-dept-group'] = repCode;
  }
  const isProd =
    !window.location.host.includes('localhost') ||
    !window.location.host.includes('dev') ||
    !window.location.host.includes('stage');

  if (!!stageval && !isProd) {
    headers['trp-request-consumer-initial'] = `ii-self-serve-service-stage`;
  } else if (!!consumerHeader) {
    headers[
      'trp-request-consumer-initial'
    ] = `ii-self-serve-service-${consumerHeader}`;
  }

  // This is replaced during webpack builds with the correct env
  const env = process.env.NODE_ENV;
  // eslint-disable-next-line no-restricted-globals
  if (env !== 'production' && location.search) {
    // eslint-disable-next-line no-restricted-globals
    const mockNameMatch = /mocks?=?([\w-]+)?/.exec(location.search);
    if (mockNameMatch) {
      headers['x-json-mocker'] = mockNameMatch[1] || '_base';
    }
  }

  const promise = new Promise((resolve, reject) => {
    _reject = reject;

    _request = superagent[options.method.toLowerCase()](url)
      // did have query and data, those must be added as optional config
      .set(headers)
      .set(options)
      .query(options.query)
      .withCredentials()
      .send(requestBody)
      .timeout(options.timeout)
      .responseType(isPDF ? 'blob' : '')
      .end((error, res) => {
        if (error) {
          // This is where we handle universal HTTP errors across all requests.
          // NOT business logic for individual calls.
          if (error.status === 504) {
            return reject({ text: JSON.stringify({ error: 'timeout' }) });
          }
          if (error.status === undefined) {
            return reject({ text: JSON.stringify({ error: 'failure' }) });
          }
          return reject(res || error);
        } else {
          resolve(res);
        }
      });
  });
  /** @ts-expect-error This is monkey-patching; TS doesn't like it. */
  promise.abort = function abort() {
    // We have two concerns on abort:
    //   * to actually end the network call
    //   * to reject the promise, which has been consumed by the calling site
    _request.abort();
    _reject();
  };

  return promise;
}

/**
 * API has been created to handle Binary format of files.
 */
export function callPdfGeneration(url: string, customOptions?, data?) {
  let _reject;
  let _request;
  const options = Object.assign(
    {},
    {
      query: {},
      method: 'GET',
      data: null,
      additionalHeaders: {},
    },
    customOptions
  );
  const requestBody = data;
  const consumerHeader = getCookie('trp-stage-routing');
  const headers = Object.assign(
    {},
    {
      apiKey: apiKey,
      Accept: 'application/pdf',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': true,
      'X-TRP-Requested-With': 'XMLHttpRequest',
      'trp-apigee-multi-target': window.location.pathname.includes('beta')
        ? 'secondary'
        : 'primary',
      'X-Frame-Options': 'SAMEORIGIN',
      'X-Content-Type-Options': 'nosniff',
      'X-XSS-Protection': 1,
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
      'import-oauth': window.location.host.includes('awstrp'),
      'trp-request-consumer-initial': 'ii-self-serve-service',
      'accept-version': '2.0',
    },
    options.additionalHeaders
  );
  if (window.location.pathname.includes('salesforce') && !!repCode) {
    headers['trp-iv-dept-group'] = repCode;
  }
  if (!!consumerHeader) {
    headers[
      'trp-request-consumer-initial'
    ] = `ii-self-serve-service-${consumerHeader}`;
  }
  // This is replaced during webpack builds with the correct env
  const env = process.env.NODE_ENV;
  // eslint-disable-next-line no-restricted-globals
  if (env !== 'production' && location.search) {
    // eslint-disable-next-line no-restricted-globals
    const mockNameMatch = /mocks?=?([\w-]+)?/.exec(location.search);
    if (mockNameMatch) {
      headers['x-json-mocker'] = mockNameMatch[1] || '_base';
    }
  }

  const promise = new Promise((resolve, reject) => {
    _reject = reject;

    _request = superagent[options.method.toLowerCase()](url)
      // did have query and data, those must be added as optional config
      .set(headers)
      .set(options)
      .query(options.query)
      .withCredentials()
      .send(requestBody)
      .timeout(options.timeout)
      .responseType('blob')
      .end((error, res) => {
        if (error) {
          // This is where we handle universal HTTP errors across all requests.
          // NOT business logic for individual calls.
          if (error.status === 504) {
            return reject({ text: JSON.stringify({ error: 'timeout' }) });
          }
          if (error.status === undefined) {
            return reject({ text: JSON.stringify({ error: 'failure' }) });
          }
          return reject(res || error);
        } else {
          resolve(res);
        }
      });
  });
  /** @ts-expect-error This is monkey-patching; TS doesn't like it. */
  promise.abort = function abort() {
    // We have two concerns on abort:
    //   * to actually end the network call
    //   * to reject the promise, which has been consumed by the calling site
    _request.abort();
    _reject();
  };

  return promise;
}

export function getEndpoint(
  endpoint: string,
  opts?: { isLocal?: boolean; path?: string },
  aemCall = false
) {
  // This allows us to send the mock calls to the mock serve when developing in local.
  // This can be further edited to separate out calls with query params
  const { NODE_ENV } = process.env;
  if (NODE_ENV === 'development') {
    let url = RemoteAPI[endpoint];
    const query = window.document.location.search;
    if (query.indexOf('?mocks=') >= 0) {
      //let urlQuery = '';
      if (url.indexOf('?') >= 0) {
        // urlQuery = `&${url.split('?')[1]}`;
        url = url.split('?')[0];
      }
      const mockNameMatch = /mocks?=?([\w-]+)?/.exec(query);
      if (mockNameMatch) {
        return opts?.path
          ? `/mocks${url}/${opts.path}/${mockNameMatch[1]}`
          : `/mocks${url}/${mockNameMatch[1]}`;
      }
      return '';
    }
  }
  const prefix = aemCall
    ? config?.url
    : window.location.host.includes('awstrp')
    ? config.api?.internal
    : config.api?.host;

  return (
    (prefix ?? '') +
    (opts?.isLocal ? LocalAPI : RemoteAPI)[endpoint] +
    (opts?.path ? `/${opts?.path}` : '')
  );
}
